import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["textarea"];

  formatBold(event) {
    event.preventDefault();
    this.wrapSelection("**", "**");
  }

  formatItalic(event) {
    event.preventDefault();
    this.wrapSelection("*", "*");
  }

  formatRegular(event) {
    event.preventDefault();
    this.removeFormatting();
  }

  wrapSelection(startTag, endTag) {
    const textarea = this.textareaTarget;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = textarea.value.substring(start, end);
    
    if (selectedText) {
      // If text is already wrapped, unwrap it first
      if (selectedText.startsWith(startTag) && selectedText.endsWith(endTag)) {
        const unwrapped = selectedText.slice(startTag.length, -endTag.length);
        textarea.value = textarea.value.substring(0, start) + unwrapped + textarea.value.substring(end);
        textarea.setSelectionRange(start, start + unwrapped.length);
      } else {
        // Wrap the selected text
        const wrapped = startTag + selectedText + endTag;
        textarea.value = textarea.value.substring(0, start) + wrapped + textarea.value.substring(end);
        textarea.setSelectionRange(start, end + startTag.length + endTag.length);
      }
    } else {
      // No selection, insert tags at cursor
      const cursorPos = textarea.selectionStart;
      textarea.value = textarea.value.substring(0, cursorPos) + startTag + endTag + textarea.value.substring(cursorPos);
      textarea.setSelectionRange(cursorPos + startTag.length, cursorPos + startTag.length);
    }
    
    textarea.focus();
    textarea.dispatchEvent(new Event("input", { bubbles: true }));
  }

  removeFormatting() {
    const textarea = this.textareaTarget;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = textarea.value.substring(start, end);
    
    if (selectedText) {
      // Remove markdown formatting
      const cleaned = selectedText
        .replace(/\*\*([^*]+)\*\*/g, "$1") // Remove **bold**
        .replace(/\*([^*]+)\*/g, "$1") // Remove *italic*
        .replace(/<strong>([^<]+)<\/strong>/gi, "$1") // Remove <strong>
        .replace(/<em>([^<]+)<\/em>/gi, "$1") // Remove <em>
        .replace(/<b>([^<]+)<\/b>/gi, "$1") // Remove <b>
        .replace(/<i>([^<]+)<\/i>/gi, "$1"); // Remove <i>
      
      textarea.value = textarea.value.substring(0, start) + cleaned + textarea.value.substring(end);
      textarea.setSelectionRange(start, start + cleaned.length);
      textarea.focus();
      textarea.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }
}

